import * as React from "react";
import { CTableRow, CTableDataCell, CCol, CRow } from "@coreui/react";
import { EditIcon, EyeCloseIcon, EyeIcon } from "../../../assets/images";
import { FUEL_SUPPLIER_ACTIONS } from "../../../constants/FuelSupplierConstants";
import Access from '../../../components/Access';
import { AccessType } from '../../../constants/roleAccessConstant';
import { useLocation } from "react-router-dom";

interface IFuelSupplierTableItemProps {
  dispatchReducer: React.Dispatch<any>;
  fuelSupplier: any;
  colValues: any[];
}

const FuelSupplierTableItem = ({
  dispatchReducer,
  fuelSupplier,
  colValues,
}: IFuelSupplierTableItemProps) => {
  const { pathname: routePath } = useLocation();

  const EditButton = () => {
    return (
      <div className={"clickable-icon"} style={{ marginLeft: "4px" }}>
        <EditIcon
          height={40}
          width={40}
          onClick={() => {
            dispatchReducer({
              type: FUEL_SUPPLIER_ACTIONS.SHOW_EDIT,
              fuelSupplierItem: fuelSupplier,
            });
          }}
        />
      </div>
    );
  };

  return (
    <CTableRow className={`fuelSupplierTableItem ${(fuelSupplier?.State === 0 || fuelSupplier?.State == null) ? "" : "inactiveRow"}`} style={{ borderBottom: "1px solid #D8D8D8" }}>
     {!!colValues &&
        colValues.length !== 0 &&
        Array.isArray(colValues) &&
        colValues.map((col_value, index) => (
          <CTableDataCell
            key={`fuelSupplierTableItem_${col_value.key || col_value.value || index}`}
            className={`RobotoMonoRg tableItem px-1 ${col_value.key}`}
            style={{ position: "relative" }}
            align="middle"
          >
            {index === colValues.length - 1 ? (
              <CRow>
                <CCol>
                  <div style={{ whiteSpace: "break-spaces" }}>
                    {col_value?.value}
                  </div>
                </CCol>
                <CCol sm="auto">
                  <CRow className="actionIcon">
                    <Access route={routePath} access={[AccessType.UPDATE]}>
                      <CCol sm="auto">
                        <EditButton />
                      </CCol>
                    </Access>
                    <Access route={routePath} access={[AccessType.DELETE]}>
                      <CCol sm="auto">
                      {/* Show EyeCloseIcon if state value is 0 (active) or State doesn't exist, otherwise show EyeIcon for inactive */}
                        {(fuelSupplier?.State === 0 || fuelSupplier?.State == null) ? (
                          <EyeCloseIcon
                            className="clickable-icon"
                            height={40}
                            width={40}
                            onClick={() => {
                              dispatchReducer({
                                type: FUEL_SUPPLIER_ACTIONS.SHOW_DEACTIVATE,
                                fuelSupplierItem: { fuelSupplier },
                              });
                            }}
                          />
                        ) : (
                          <EyeIcon
                            className="clickable-icon"
                            height={40}
                            width={40}
                            onClick={() => {
                              dispatchReducer({
                                type: FUEL_SUPPLIER_ACTIONS.SHOW_ACTIVATE,
                                fuelSupplierItem: { fuelSupplier },
                              });
                            }}
                          />
                        )}
                      </CCol>
                    </Access>
                  </CRow>
                </CCol>
              </CRow>
            ) : (
              col_value?.value
            )}
          </CTableDataCell>
        ))}
    </CTableRow>
  );
};

export default FuelSupplierTableItem;
